import React from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';

// Material components
import { Box, Icon, Typography, useMediaQuery } from '@material-ui/core';

// Styles 
import useStyles from '../../../assets/styles/components/cards/itemListProgramCard/itemListProgramCardStyle';

// Utils
import objectIsEmpty from '../../../utils/objectIsEmpty';

// Components
import Base from '../components/Base';
import ItemListProgramCardContent from './components/ItemListProgramCardContent';
import ItemListProgramCardDetail from './components/ItemListProgramCardDetail';

const ItemListProgramCard = ({programId, userId, sourceId, name, backgroundImage, levelId, content, dataDetail, membershipIdList, isLogged, onClick, onClickMixPanelCard}) => {
    const classes = useStyles();
    const isResponsive = useMediaQuery(theme => theme.breakpoints.down('xs'));
    const [dropdownDetail, setDropdownDetail] = React.useState(false);

    const hasDetail = !objectIsEmpty(dataDetail);

    const handleClick = (id) => () => {
        if(!!onClickMixPanelCard) onClickMixPanelCard();
        if (!!onClick) onClick({id});
    };


    const onClickDropdownDetail = () => setDropdownDetail(prevState => !prevState);

    return (
        <Base onClick={hasDetail ? () => null : handleClick((programId).toString())} className={classes.rootBase} hasClickEvent={!hasDetail && (!!onClickMixPanelCard || !!onClick)}>
            <Box className={classes.bodyContainer}>
                <ItemListProgramCardContent backgroundImage={backgroundImage} hasDetail={hasDetail} levelId={levelId} name={name} sourceId={sourceId} expandArrowIcon={dropdownDetail} onClickExpandSection={onClickDropdownDetail} content={content} membershipIdList={membershipIdList}/>
                {
                    !objectIsEmpty(dataDetail) && dropdownDetail && 
                    <ItemListProgramCardDetail 
                        dataDetail={dataDetail}
                        content={content}
                        membershipIdList={membershipIdList}
                       // onClickToDetail={handleClick((programId).toString())}
                        />
                }
                
            </Box>


        </Base>
    );
};

ItemListProgramCard.defaultProps = {
    membershipIdList: [],
    dataDetail: {},
};

ItemListProgramCard.propTypes = {
    programId: PropTypes.number.isRequired,
    userId: PropTypes.number,
    sourceId: PropTypes.number.isRequired,
    name: PropTypes.string.isRequired,
    backgroundImage: PropTypes.string.isRequired,
    levelId: PropTypes.string.isRequired,
    content: PropTypes.shape({
        price: PropTypes.shape({
            number: PropTypes.number,
            listNumber: PropTypes.number,
        }),
        showLabel: PropTypes.bool.isRequired,
        showPrice: PropTypes.bool.isRequired,
        labelToShow: PropTypes.string.isRequired,
        typeLabel: PropTypes.number.isRequired,
    }).isRequired,
    dataDetail: PropTypes.shape({
        modalityId: PropTypes.number,
        documentLabel: PropTypes.string,
        subjectLength: PropTypes.number,
        duration: PropTypes.number,
        language: PropTypes.string,
        description: PropTypes.string,
    }),
    membershipIdList: PropTypes.arrayOf(PropTypes.number),
    isLogged: PropTypes.bool,
    onClick: PropTypes.func,
    onClickMixPanelCard: PropTypes.func,
};

export default ItemListProgramCard;